export const environment = {
  production: false,
  qualys: false,
  googleMapsApiKey: 'AIzaSyDVvlMjZlNzR_b6h-rDxue-WIKgpyc8x9s',
  apiUrl: 'https://de-dev-backend-insp-b6h362l2za-uc.a.run.app/',
  endpoint: {
    directLogging: 'v2/directLogging',
    verifyInspectionURL: 'verifyInspectionURL',
    verifyOtp: 'v2/verifyOtp',
    getRefreshToken: 'getRefreshToken',
    getTask: 'getTask',
    updateFileDetails: 'updateFileDetails',
    getTaskProperties: 'getTaskProperties',
    createTaskUserActivity: 'createTaskUserActivity',
    getTwilioToken: 'getTwilioToken',
    checkTwilioRoom: 'checkTwilioRoom',
    storeTaskLatLng: 'storeTaskLatLng',
    twilioRoomParticipantCount: 'twilioRoomParticipantCount',
    checkTwilioParticipantOnServer: 'checkTwilioParticipantOnServer',
    changeRoomStatus: 'changeRoomStatus',
    getStatusDetailsJson: 'getStatusDetailsJson',
    getTaskMasterLOV: 'getTaskMasterLOV',
    deleteMediaDetails: 'deleteMediaDetails'
  },
};
